let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bJykp")).then(() => parcelRequire('8Rjw5'));